export const APP_UWORKER_URL = process.env.REACT_APP_APP_UWORKER_URL;
export const APP_COMPANY_URL = process.env.REACT_APP_APP_COMPANY_URL;
export const APP_AGREEMENT_URL = process.env.REACT_APP_AGREEMENT_URL || '';
export const API_ADDRESS_URL = process.env.REACT_APP_ADDRESS_API_URL || '';
export const API_SALARY_URL = process.env.REACT_APP_SALARY_API_URL || '';
